import {Component, ElementRef} from "@angular/core";
import { DataService } from "src/app/service/data.service";
import {CommonService} from "../../service/common.service";

//@Component({
//	selector: 'appStatus',
//	templateUrl: './AppStatus.component.html',
//	styleUrls: ['./AppStatus.component.scss'],
@Component({
	selector: 'appStatus',
	template: `
	<!--
		<loading-icon *ngIf="loadingList.length>0"></loading-icon>
	-->
	<div *ngIf="hasProgressBar" class="progress-bar-bg"></div>
	<div class="uploadingState" [ngClass]="[uploadingState, effect]" [class.has-progress-bar]="hasProgressBar">
		<div style="flex: 1; margin-left: 40px; text-align: center; " *ngIf="hasProgressBar">
			<div class="hint">{{ {tc: '上傳答案中', sc: '上传答案中', en: 'uploading'}[dataService.lang] }}</div>
			<progress-bar
				style="--section-maincolor: #ff0061; --progress-bar-bgcolor: #CCCCCC; line-height: 0; display: block"
				[height]="4"
				[maxWidth]="60"
				[total]="uploading_count" [value]="uploading_count - uploadingList.length"></progress-bar>
		</div>
	</div>
		`,
	styleUrls: ['./AppStatus.component.scss'],
})

export class AppStatusComponent {
	// STATE_SYNC
	// STATE_CONTENT_LOADING
	// STATE_LESSON_RECONNECT
	public uploadingList:any[] = [];
	public uploadingState:string = "none";
	public effect:string = "wait";
	static instance:AppStatusComponent;
	public uploading_count = 0;
	public hasProgressBar = false;

	protected uploadingFadeOutTimer:number = -1;

	constructor(public dataService: DataService, public eleRef: ElementRef, public coms: CommonService) {
		AppStatusComponent.instance = this;
	}

	public getRandomString():string {
        return + new Date() + '-' + Math.round(Math.random() * 1000)
    }

	public updatePosition() {
		let dom_list = document.querySelectorAll('ro-book-preview-component .host .top-button-container > *');
		if (dom_list.length < 2) {
			this.eleRef.nativeElement.style.right = '100px';
			return;
		}
		let dom = dom_list[1];
		let rect = dom.getBoundingClientRect();
		this.eleRef.nativeElement.style.right = (window.innerWidth - rect.left + 5) + 'px';
	}

	public addLoading():string {
		this.updatePosition();
		var key:string = this.getRandomString();
		this.uploadingList.push(key);
		this.uploading_count++;
		this.uploadingState = "uploading";
		this.effect = "fade-in";
		return key;
	}

	public removeLoading(key:string):void {
		var haveLoding:boolean = this.uploadingList.length>0;
		this.uploadingList = this.uploadingList.filter(e =>e!=key);
		if(this.uploadingList.length == 0) {
			if (this.hasProgressBar) {
				this.coms.timeout(500).then(() => {
					this.uploadingState = "upload_success";
					this.effect = "fade-out";
					this.uploading_count = 0;
				})
			} else {
				this.uploadingState = "upload_success";
				this.effect = "fade-out";
				this.uploading_count = 0;
			}
			if(this.uploadingFadeOutTimer!=-1)
				clearTimeout(this.uploadingFadeOutTimer);
			this.uploadingFadeOutTimer = window.setTimeout(() => {
				this.uploadingFadeOutTimer = -1;
				this.effect = "wait";
			}, 1500);
		}
			
	}

	protected _callAPI(api:string, params:any[]):Promise<any> {
		var recKey:string = this.addLoading();

		return new Promise<any>((resolve, reject) => {
			this.dataService.post2({data:{api:api, json:params}, loading: false}).then((res:any)=>{
				this.removeLoading(recKey);
				resolve(res);
			}).catch(reason=>{
				this.removeLoading(recKey);
				reject(reason);
			});
		});
	}

	public static callAPI(api:string, params:any):Promise<any> {
		return AppStatusComponent.instance._callAPI(api, params);
	}

}